<template>
  <q-select
    :model-value="modelValue"
    :options="countries"
    option-value="iso2"
    :virtual-scroll-slice-size="countries.length"
    popup-content-class="relative-position"
    popup-content-style="height: 300px; max-height: 300px"
    menu-anchor="bottom left"
    hide-bottom-space
    hide-dropdown-icon
    borderless
    @update:model-value="$emit('update:modelValue', $event)"
    @popup-hide="searchText = ''"
  >
    <template v-slot:before-options>
      <CountrySearch
        :model-value="searchText"
        @update:model-value="searchText = $event"
      />
    </template>
    <template v-slot:option="scope">
      <q-item
        :key="scope.opt.iso2"
        clickable
        v-bind="scope.itemProps"
      >
        <q-item-section side>
          <span :class="['v3q_tel__flag', scope.opt.iso2.toLowerCase()]"></span>
        </q-item-section>
        <q-item-section no-wrap>
          <span>
            (+{{ scope.opt.dialCode }}) {{ scope.opt.name }}
          </span>
        </q-item-section>
      </q-item>
      <q-separator />
    </template>
    <template v-slot:selected-item="scope">
      <dial-code-country-flag :dial-code="scope.opt.dialCode" />
      <span class="on-right text-bold">+{{ scope.opt.dialCode }}</span>
    </template>
    <template v-slot:no-option>
      <CountrySearch
        :model-value="searchText"
        @update:model-value="searchText = $event"
      />
      <div class="q-pa-sm">Country not found.</div>
    </template>
  </q-select>
</template>

<style lang="scss">
@import './flags.css';
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { filterCountries, Country, countries } from './countries';
import CountrySearch from './CountrySearch.vue';
import DialCodeCountryFlag from './DialCodeCountryFlag.vue';

interface Data {
  searchText: string;
}

export default defineComponent({
  components: { CountrySearch, DialCodeCountryFlag },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object as () => Country,
      required: true,
    },
  },
  data(): Data {
    return {
      searchText: '',
    };
  },
  computed: {
    countries(): Country[] {
      const term = this.searchText.toLowerCase().trim();
      return term === '' ? countries : filterCountries(term);
    },
  },
});
</script>
